import React, { useEffect, useState } from "react";
import { Image } from "react-konva";
const DownloadLogoImage = ({
  imageProperties,
  differenceFactor,
  xPointsToAdd,
  yPointsToAdd,
  originalImageWidth,
  originalImageHeight,
  setImageCanvasExceededDispatch,
}) => {
  const [xCords, setXCords] = useState(imageProperties.x);
  const [yCords, setYCords] = useState(imageProperties.y);
  const [containerHight, setContainerHight] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);

  const shapeRef = React.useRef();

  useEffect(() => {
    if ((containerHight, containerWidth)) {
      let x = parseInt(
          imageProperties.x -
            getCenterPoint().x * (imageProperties.scaleX * differenceFactor)
        ),
        y = parseInt(
          imageProperties.y -
            getCenterPoint().y * (imageProperties.scaleY * differenceFactor)
        );

      if (
        x + 2 < 0 ||
        x + containerWidth * (imageProperties.scaleX * differenceFactor) >
          originalImageWidth + 0 ||
        y < 0 ||
        y + containerHight * (imageProperties.scaleY * differenceFactor) >
          originalImageHeight + 0
      ) {
        setImageCanvasExceededDispatch(true);
      } else {
        setImageCanvasExceededDispatch(false);
      }
    }
  }, [containerHight, containerWidth]);
  useEffect(() => {
    if (imageProperties.property !== "template") {
      let xDifference = imageProperties.x - xPointsToAdd;
      let yDifference = imageProperties.y - yPointsToAdd;
      setXCords(xDifference * differenceFactor);
      setYCords(yDifference * differenceFactor);
    } else {
      setXCords(imageProperties.x);
      setYCords(imageProperties.y);
    }
  }, [imageProperties, differenceFactor, xPointsToAdd, yPointsToAdd]);

  function getCenterPoint() {
    const centerPoint = {
      x: imageProperties.image.width / 2,
      y: imageProperties.image.height / 2,
      deg: imageProperties.deg,
    };
    return centerPoint;
  }
  useEffect(() => {
    if (imageProperties.image) {
      // you many need to reapply cache on some props changes like shadow, stroke, etc.
      shapeRef.current.cache();
      setContainerHight(shapeRef.current.height());
      setContainerWidth(shapeRef.current.width());
    }
  }, [imageProperties.image]);
  return (
    <>
      {imageProperties.image ? (
        <Image
          keepRatio={true}
          ref={shapeRef}
          rotation={imageProperties.deg}
          x={xCords}
          y={yCords}
          scaleX={imageProperties.scaleX * differenceFactor}
          scaleY={imageProperties.scaleY * differenceFactor}
          offsetX={getCenterPoint().x}
          offsetY={getCenterPoint().y}
          image={imageProperties.image}
          opacity={imageProperties.opacity}
          globalCompositeOperation="source-over"
        />
      ) : null}
    </>
  );
};

export default DownloadLogoImage;
